import { BREAKPOINT_SIZES } from '@/styles/mixins/breakpoint-mixin'
import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ colors }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(
      -45deg,
      ${colors.brand.primary[400]},
      ${colors.brand.primary[500]}
    );
    background-size: 400% 400%;
    animation: gradient 10s ease infinite;
    @media (max-width: ${BREAKPOINT_SIZES.phone.maxWidth}) {
      padding: 16px;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `,
  mainCard: () => css`
    padding-top: 20vh;
    @media (max-width: ${BREAKPOINT_SIZES.phone.maxWidth}) {
      padding: 0;
    }
  `,

  footer: ({ colors }) => css`
    div & span {
      color: ${colors.background.white};
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
    margin: 16px;
  `,

  loadingScreen: () => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: white;
    h3 {
      margin-bottom: 16px;
    }
    svg {
      height: 100px;
      width: 100px;
    }
  `,

  linkSupport: ({ colors }) => css`
    color: ${colors.background.white};
    margin-bottom: 16px;
    &:hover {
      color: ${colors.background.white} !important;
    }
    cursor: pointer;
  `,
})

export default useStyles
